<script lang="ts">
  export let open: boolean = false;
</script>

<svg class="animate" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 14">
  <path
    class="animate translate"
    class:open
    style:fill="currentColor"
    style:stroke="currentColor"
    style:stroke-width="1px"
    style:stroke-linecap="round"
    d="m60 7-6 6m0-12 6 6"
  />
  <path
    class="animate translate"
    class:open
    style:fill="currentColor"
    style:stroke="currentColor"
    style:stroke-width="1px"
    style:stroke-linecap="round"
    d="M60 7 1 7"
  />
</svg>

<style>
  svg {
    width: var(--arrow-width);
    transform: translateY(1px);
  }

  .animate {
    transition: all var(--transition);
  }

  .translate {
    transform: translateX(calc(var(--arrow-width) * -0.666));
  }

  .open {
    transform: none;
    width: var(--arrow-width);
  }
</style>
